import frontendSetRequest from "./requests/frontend-set-request";

const logRepository = {
    frontendSet: frontendSetRequest,
};

export default logRepository;
